import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Type,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import {
  MatChipGrid,
  MatChipInput,
  MatChipInputEvent,
  MatChipRemove,
  MatChipRow,
} from '@angular/material/chips';
import { MatOption } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { Observable, isObservable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';

interface ChipListProps extends FormlyFieldProps {
  chips: any[] | Observable<any[]>;
  labelProp: string;
  valueProp: string;
  showAutoComplete?: boolean;
}

export interface FormlyChipListFieldConfig
  extends FormlyFieldConfig<ChipListProps> {
  type: 'chip-list' | Type<FormlyMatChipListComponent>;
}

@Component({
  selector: 'app-formly-mat-chip-list',
  templateUrl: './formly-mat-chip-list.component.html',
  styleUrls: ['./formly-mat-chip-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatChipGrid,
    NgFor,
    MatChipRow,
    NgIf,
    MatChipRemove,
    MatIcon,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatChipInput,
    MatAutocomplete,
    MatOption,
    AsyncPipe,
    FormlyModule,
    MatInputModule,
  ],
})
export class FormlyMatChipListComponent
  extends FieldType<FieldTypeConfig<ChipListProps>>
  implements OnInit
{
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredValues!: Observable<any[]>;
  allValues: any[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.field.props?.chips && isObservable(this.field.props.chips)) {
      this.field.props.chips
        .pipe(
          tap(t => {
            this.allValues = t;
          }),
          tap(() => {
            this.filteredValues = this.formControl.valueChanges.pipe(
              startWith(null),
              map(value =>
                value ? this._filter(value) : this.allValues.slice()
              )
            );
          })
        )
        .subscribe();
    } else {
      if (this.field.props?.chips && !isObservable(this.field.props.chips))
        this.allValues = this.field.props.chips;

      this.filteredValues = this.formControl.valueChanges.pipe(
        startWith(null),
        map(value => (value ? this._filter(value) : this.allValues.slice()))
      );
    }
  }

  add(event: MatChipInputEvent): void {
    // const value = event.value || '';
    // // console.log(event);
    // // if (value) this.selectedValues.push(value);
    // event.chipInput!.clear();
    // this.chipListCtrl.setValue(null);
  }

  remove(value: any): void {
    const index = this.formControl.value.indexOf(value);
    if (index >= 0) {
      this.formControl.value.splice(index, 1);
      this.field.formControl.setValue(this.formControl.value);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.formControl.value.push(event.option.value);
    //this.chipListCtrl.setValue(null);
    this.field.formControl.setValue(this.formControl.value);
  }

  private _filter(value: any): any[] {
    if (this.field.props?.valueProp) {
      const key = value[this.field.props.valueProp];

      return this.allValues.filter(f => {
        const tmp = f[this.field.props.valueProp];
        return tmp == key;
      });
    } else {
      if (typeof value === 'string') {
        const filterValue = value.toLowerCase();
        return this.allValues.filter(value =>
          value.toLowerCase().includes(filterValue)
        );
      } else {
        return this.allValues;
      }
    }
  }
}
